import { render, staticRenderFns } from "./VideoAddQa.vue?vue&type=template&id=d995ca36&scoped=true&"
import script from "./VideoAddQa.vue?vue&type=script&lang=js&"
export * from "./VideoAddQa.vue?vue&type=script&lang=js&"
import style0 from "./VideoAddQa.vue?vue&type=style&index=0&id=d995ca36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d995ca36",
  null
  
)

export default component.exports